var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/MyADGScreenings/MyADGScreeningsInner.jinja"] = require( "front/components/MyADGScreenings/MyADGScreeningsInner.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MyADGScreenings/MyADGScreenings.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MyADGScreenings/MyADGScreenings.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/MyADGScreenings/MyADGScreeningsInner.jinja", false, "assets/app/front/components/MyADGScreenings/MyADGScreenings.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "MyADGScreeningsInner")) {
var t_7 = t_4.MyADGScreeningsInner;
} else {
cb(new Error("cannot import 'MyADGScreeningsInner'")); return;
}
context.setVariable("MyADGScreeningsInner", t_7);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_9 = "";t_9 += "\n    <div class=\"MyADGScreenings\">\n        <h2>MEMBERS ONLY SCREENINGS</h2>\n        <figure>\n            <figcaption>";
t_9 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"previewRendered")), env.opts.autoescape);
t_9 += "</figcaption>\n            <img src=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"cover")),"w680_url"), env.opts.autoescape);
t_9 += "\"\n              srcset=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"cover")),"w1366_url"), env.opts.autoescape);
t_9 += " 1366w,\n                      ";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"cover")),"w680_url"), env.opts.autoescape);
t_9 += " 680w\"\n              sizes=\"(max-width: 759px) 1, ";
t_9 += "\n                     100vw\"\n              alt=\"\">\n        </figure>\n\n        <div class=\"MyADGScreenings-listWrapper\">\n            ";
t_9 += runtime.suppressValue((lineno = 18, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MyADGScreeningsInner"), "MyADGScreeningsInner", context, [runtime.makeKeywordArgs({"data": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"list")})])), env.opts.autoescape);
t_9 += "\n        </div>\n\n        <div ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"hasMore")) {
t_9 += "style=\"display:none\"";
;
}
t_9 += " class=\"MyADGScreenings-showMoreButton\">\n            <button>More</button>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_9);
});
context.addExport("MyADGScreenings");
context.setVariable("MyADGScreenings", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MyADGScreenings/MyADGScreenings.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MyADGScreenings/MyADGScreenings.jinja
// module id = 519
// module chunks = 0